import { MeshLine, MeshLineMaterial, MeshLineRaycast } from 'three.meshline';
import * as THREE from 'three'

// 2D Random
export let perlin = {
	rand_vect: function(){
	    let theta = Math.random() * 2 * Math.PI;
	    return {x: Math.cos(theta), y: Math.sin(theta)};
	},
	dot_prod_grid: function(x, y, vx, vy){
	    let g_vect;
	    let d_vect = {x: x - vx, y: y - vy};
	    if (this.gradients[[vx,vy]]){
		g_vect = this.gradients[[vx,vy]];
	    } else {
		g_vect = this.rand_vect();
		this.gradients[[vx, vy]] = g_vect;
	    }
	    return d_vect.x * g_vect.x + d_vect.y * g_vect.y;
	},
	smootherstep: function(x){
	    return 6*x**5 - 15*x**4 + 10*x**3;
	},
	interp: function(x, a, b){
	    return a + this.smootherstep(x) * (b-a);
	},
	seed: function(){
	    this.gradients = {};
	    this.memory = {};
	},
	get: function(x, y) {
	    if (this.memory.hasOwnProperty([x,y]))
		return this.memory[[x,y]];
	    let xf = Math.floor(x);
	    let yf = Math.floor(y);
	    //interpolate
	    let tl = this.dot_prod_grid(x, y, xf,   yf);
	    let tr = this.dot_prod_grid(x, y, xf+1, yf);
	    let bl = this.dot_prod_grid(x, y, xf,   yf+1);
	    let br = this.dot_prod_grid(x, y, xf+1, yf+1);
	    let xt = this.interp(x-xf, tl, tr);
	    let xb = this.interp(x-xf, bl, br);
	    let v = this.interp(y-yf, xt, xb);
	    this.memory[[x,y]] = v;
	    return v;
	}
    }
    perlin.seed();

export class AnimLine {
	constructor(pos, dirInit, thickness, length, colour) {
		this.segmentLength = .31+(1.8*length);
		this.speed = 1.0;
		this.nbrOfPoints = 10;
		this.points = [];
		this.turbulence = 0.25;
		this.startTimer = 0.;
		this.startOffset = Math.random()*.5;

		let pointPos = pos.clone();
		let initialPos = pos.clone();
		pointPos.x *= .0001;//noise resolution 
		pointPos.y *= .0001;
		let dir = new THREE.Vector3(0,0,0);
		dir.x = dirInit.x;
		dir.y = dirInit.y;
		for (let i = 0; i < this.nbrOfPoints; i++) {
			dir.x += perlin.get(pointPos.x+10., pointPos.y+10.);
			dir.y += perlin.get(pointPos.x+10000., pointPos.y+10000.);
			dir = dir.normalize();
			let newDir = new THREE.Vector3(
				dir.x,
				dir.y,
				0.,
			).multiplyScalar(this.segmentLength);
			pointPos.x += newDir.x;
			pointPos.y += newDir.y;

			let newPos = pos.clone();
			newPos.x = initialPos.x + pointPos.x;
			newPos.y = initialPos.y + pointPos.y;
			this.points.push(newPos);
		}
		this.linePoints = new THREE.Geometry().setFromPoints(new THREE.CatmullRomCurve3(this.points).getPoints(10));

		this.line = new MeshLine();
		this.line.setGeometry(this.linePoints);
		this.geometry = this.line.geometry;

		this.material = new MeshLineMaterial({
			transparent: true,
			opacity: 1.,//.1+ Math.random()*.7,
			lineWidth: thickness,//.11 + Math.random() * 0.1,
			color: colour,
			dashArray: 2,     // always has to be the double of the line
			dashOffset: 0,    // start the dash at zero
			dashRatio: .55 + (.99 - .5) * (1. - length),  // visible length range min: 0.99, max: 0.5
			depthTest:false
		});
		this.shadowMaterial = new MeshLineMaterial({
			transparent: true,
			opacity: 1.,//.1+ Math.random()*.7,
			lineWidth: thickness,//.11 + Math.random() * 0.1,
			color: new THREE.Color(Math.random()*.8, Math.random()*.6, Math.random()*.3),
			dashArray: 2,     // always has to be the double of the line
			dashOffset: 0,    // start the dash at zero
			dashRatio: .55 + (.99 - .5) * (1. - length),  // visible length range min: 0.99, max: 0.5
			depthTest:false
		});

		// Build the Mesh
		this.lineMesh = new THREE.Mesh(this.geometry, this.material);
		this.lineMesh.position.x = pos.x;
		this.lineMesh.position.y = pos.y;
		this.lineMesh.position.z = pos.z;
		this.lineShadow = this.lineMesh.clone();
		this.lineShadow.material = this.shadowMaterial;
		this.lineShadow.material.opacity = .6;
		this.lineShadow.material.color = new THREE.Color(0x000000);
		this.lineShadow.position.x -= .18; 
		this.lineShadow.position.y -= .18; 

		this.lineGroup = new THREE.Group();
		this.lineGroup.add(this.lineShadow);
		this.lineGroup.add(this.lineMesh);
		

	}

	update() {
		if (this.startOffset < this.startTimer) {
			// Check if the dash is out to stop animate it.
			if (this.lineMesh.material.uniforms.dashOffset.value < - 1.5){
				this.lineMesh.material.uniforms.dashOffset.value = 0.;
				this.lineShadow.material.uniforms.dashOffset.value = 0.;
			}

			// Decrement the dashOffset value to animate the path with the dash.
			this.lineMesh.material.uniforms.dashOffset.value -= 0.0031*this.speed;
			this.lineShadow.material.uniforms.dashOffset.value -= 0.0031*this.speed;
		}
		else{
			this.startTimer += 0.04;
		}
	}

}